import { v4 as uuidv4 } from 'uuid';

export function DispositionLayout(props = {}, childrenComponents = []) {
	return {
		componentName: 'DispositionLayout',
		componentId: uuidv4(),
		props: Object.assign(props),
		childrenComponents,
	};
}
